import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { PaymentPanel, type PaymentMethod } from "@/components/dashboard/payment-panel";

export const Route = createFileRoute("/panel-preview")({ component: Preview });

function Preview() {
  const [method, setMethod] = useState<PaymentMethod>("cash");
  const [cash, setCash] = useState("");
  const [split, setSplit] = useState(1);
  const amountDue = 487.5 / split;
  return (
    <div className="h-screen bg-[#f7f7f8] p-5">
      <div className="grid h-full grid-cols-3 gap-4">
        <div />
        <div />
        <PaymentPanel
          amountDue={amountDue}
          remaining={amountDue}
          paid={0}
          tenders={[]}
          paymentMethod={method}
          onSelectMethod={setMethod}
          cashReceived={cash}
          onKeypadPress={(k) =>
            setCash((c) => (k === "C" ? "" : k === "back" ? c.slice(0, -1) : c + k))
          }
          onSetAmount={setCash}
          onCompletePayment={() => {}}
          splitCount={split}
          onChangeSplit={setSplit}
          completeLabel="Ödemeyi Tamamla"
          plannedShares={null}
          onOpenSplit={() => {}}
          activeShareIndex={0}
          paidSharesList={[]}
        />
      </div>
    </div>
  );
}
